/**
 * Zahlungsart of a Zahlung. No cash: a cash receipt belongs in a Kassenbuch
 * (§146a AO), which Therame does not keep.
 */
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["BANK_TRANSFER"] = "bank_transfer";
    PaymentMethod["CARD"] = "card";
})(PaymentMethod || (PaymentMethod = {}));
//# sourceMappingURL=payment-method.enum.js.map